export enum ChipSelection {
  ENTIRE_ABSENCE = 'entireAbsence',
  SELECTED_DATE = 'selectedDate',
  CUSTOM = 'custom'
}

export type SelectedChip = (typeof ChipSelection)[keyof typeof ChipSelection];
